import API from './API'
import Client from "@/ts/interfaces/Client";
import {Deserialize} from "cerialize";
import Newsletter from "@/ts/interfaces/Newsletter";

export default class Clients extends API {

    static getAllClients(): Promise<Client[]> {
        return super.baseRequest("GET", `admin/clients/`, null).then(res => {
            return Deserialize(res.clients, Client)
        });
    }


    static getSingleClient(clientId: number): Promise<Client> {
        return super.baseRequest("GET", `admin/clients/${clientId}`, null).then(res => {
            return Deserialize(res, Client)
        });
    }


    static createClient(client: Client) {
        return API.baseRequest("POST", `admin/clients/`, client)
    }


    static updateClient(clientId: number, client: Client) {
        return API.baseRequest("PUT", `admin/clients/${clientId}`, client)
    }


    static deleteClient(clientId: number) {
        return super.baseRequest("DELETE", `admin/clients/${clientId}`, null);
    }


    static sendNewsletter(newsletter: Newsletter): Promise<Newsletter> {
        return super.baseRequest("POST", `admin/clients/newsletter/`, newsletter);
    }
}